var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("page-header", { attrs: { page: _vm.page } }),
      _c("menu-options", { attrs: { "menu-title": _vm.navTitle } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }